export const calculateNumPages = (items, pageSize) => {
  if (!items || !pageSize) {
    return 0;
  } else if (items % pageSize === 0) {
    return parseInt(items / pageSize);
  } else {
    return parseInt(items / pageSize + 1);
  }
};

export const getPrevs = (selected, howMuch = 1) => {
  const minValue = 1;
  const results = [];
  let i;
  let s = selected;
  for (i = 0; i < howMuch; i++) {
    if (s - 1 > minValue) {
      results.push(s - 1);
      s--;
    }
  }
  return results.reverse();
};

export const getNexts = (selected, maxValue, howMuch = 1) => {
  const results = [];
  let i;
  let s = selected;
  for (i = 0; i < howMuch; i++) {
    if (s + 1 < maxValue) {
      results.push(s + 1);
      s++;
    }
  }
  return results;
};

export const getPageNumbers = (selected, numPages, howMuch = 1) => {
  let results = [1];
  if (numPages === 1) {
    return [1];
  } else if (numPages < 1) {
    return [];
  } else {
    const prevs = getPrevs(selected, howMuch);
    const nexts = getNexts(selected, numPages, howMuch);
    if (prevs[0] && prevs[0] !== 2) {
      results.push(0);
    }
    results = results.concat(prevs);
    if (selected !== 1 && selected !== numPages) {
      results.push(selected);
    }
    results = results.concat(nexts);
    if (nexts[nexts.length - 1] && nexts[nexts.length - 1] + 1 !== numPages) {
      results.push(0);
    }
    results.push(numPages);
    return results;
  }
};
